// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2019-09-30 12:55:19 +0200 (Mon, 30 Sep 2019) $
//  Author    :
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 104222 $
//  Purpose   : background tasks for widget package
// =============================================================================
// ---Third-party imports
import {takeEvery, put} from 'redux-saga/effects'

// ---Framework imports
import {delay} from 'uix/sagas'
import Api from 'uix/api'
import log from 'uix/logging'

// ---Local imports
import {loadWidgetData, setWidgetData} from './actions'

// ---Globals
function* _loadWidgetData({payload, meta}) {
  let otids = payload.otids
  let {data, error} = yield Api.get('/api/getWidgetData', {otids: otids.join(',')})
  if (error) {
    log.error('bad things on getWidgetData')
  } else {
    yield put(setWidgetData(data.widgetData))
  }
}

export const sagas = {
  loadWidgetData: takeEvery(loadWidgetData, _loadWidgetData),
}
